<template>
  <div
    class="table_actions "
    :class="[rotate && 'table_actions-rotate']">
    <call-tooltip
      placement="top"
      :content="!rotate ? expandText : collapseText">
      <call-button
        outlet
        type="success"
        round
        not-border
        :icon="dataAngleUp"
        @click="clickAction('toggle')" />
    </call-tooltip>
  </div>
</template>

<script>
import CallButton from '../common/CallButton';
import { faAngleUp } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'CallTableGiftsReportActions',
  components: { CallButton },
  props: {
    rotate: {
      type: Boolean,
      default: false
    },
    expandText: {
      type: String,
      default: 'Show Details'
    },
    collapseText: {
      type: String,
      default: 'Hide Details'
    }
  },
  data () {
    return {
      dataAngleUp: faAngleUp
    };
  },
  methods: {
    clickAction (action) {
      this.$emit('on-action', action);
    }
  }
};
</script>

<style lang="scss" scoped>
  .table_actions .call-button {
    transform: rotate(180deg);
    &:focus {
      box-shadow: none !important;
    }
    &:hover {
      background-color: transparent;
      color: #20a052;
    }
  }
  .table_actions-rotate .call-button {
    transform: rotate(360deg);
    margin-left: 4px;
  }
</style>
